import React from 'react';
import './AuthModal.css';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSignIn: () => void;
  onRegisterUsername: () => void;
  isSignedIn: boolean;
  hasUsername: boolean;
}

export function AuthModal({
  isOpen,
  onClose,
  onSignIn,
  onRegisterUsername,
  isSignedIn,
  hasUsername,
}: AuthModalProps) {
  if (!isOpen) return null;

  const getModalContent = () => {
    if (!isSignedIn) {
      return {
        title: 'Sign In Required',
        message: 'You need to sign in with Privy to start playing Kingsomni!',
        primaryAction: {
          label: 'Sign In with Privy',
          onClick: onSignIn,
          className: 'auth-modal-primary-btn',
        },
        secondaryAction: {
          label: 'Cancel',
          onClick: onClose,
          className: 'auth-modal-secondary-btn',
        },
      };
    }

    if (!hasUsername) {
      return {
        title: 'Profile Required',
        message: 'You need a Kingsomni profile to start playing and compete on the leaderboard!',
        primaryAction: {
          label: 'Create Profile',
          onClick: onRegisterUsername,
          className: 'auth-modal-primary-btn',
        },
        secondaryAction: {
          label: 'Cancel',
          onClick: onClose,
          className: 'auth-modal-secondary-btn',
        },
      };
    }

    return null;
  };

  const content = getModalContent();
  if (!content) return null;

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-header">
          <h2 className="auth-modal-title">{content.title}</h2>
          <button className="auth-modal-close" onClick={onClose}>
            x
          </button>
        </div>

        <div className="auth-modal-body">
          <p className="auth-modal-message">{content.message}</p>
        </div>

        <div className="auth-modal-footer">
          <button className={content.primaryAction.className} onClick={content.primaryAction.onClick}>
            {content.primaryAction.label}
          </button>
          <button className={content.secondaryAction.className} onClick={content.secondaryAction.onClick}>
            {content.secondaryAction.label}
          </button>
        </div>
      </div>
    </div>
  );
}
